export default __webpack_public_path__ + "static/media/completed.cd5ff8ea.svg";